import { render, staticRenderFns } from "./CallTasks.vue?vue&type=template&id=475cb6fd"
import script from "./CallTasks.vue?vue&type=script&lang=js"
export * from "./CallTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports